
import { PvdLink } from '@fmr-ap109253/apex-kit/dist/lib/src/pvd';
import { Component, Vue, Prop } from 'vue-property-decorator';
import Popover from '../popovers/Popover.vue';

@Component({
    components: {
        Popover,
    },
})
export default class LinkableLabel extends Vue {
    @Prop() labelId!: string;
    @Prop() forId!: string;
    @Prop() labelText!: string;
    @Prop({ default: false }) hasLink!: boolean;
    @Prop() popoverType!: string;

    cyLinkId = '';

    created() {
        this.cyLinkId = this.labelId + '-link-cy';
    }

    mounted() {
        if (this.hasLink) {
            (this.$refs['ref-popover'] as Popover).setTarget(this.$refs['popover-trigger'] as PvdLink);
        }
    }

    /**
     * Opens a popover containing a description of the field.
     */
    public openPopover(): void {
        (this.$refs['ref-popover'] as Popover).openModal();
    }
}
